/**
 * Dependency GraphQL Fragments
 *
 * Complete fragment for Dependency primitive matching GraphQL API.
 * All visible (non-skipped) fields from GqlDependency are included.
 */

import { gql } from '@apollo/client';

/**
 * Complete Dependency fields fragment — all non-skipped GqlDependency fields.
 */
export const DEPENDENCY_FIELDS_FRAGMENT = gql`
  fragment DependencyFields on Dependency {
    id
    name
    description
    parentId
    originalId
    recordVersion
    isActive
    dependencyType
    isConditional
    condition
    satisfactionCriteria
    status
    lagConfiguration
    canBypass
    bypassApprovalRequired
    bypassReason
    dependencyMetadata
    metadata
    active
    version
    targetFormulas
    isCriticalPath
    criticalPathFormulas
    lastEvaluatedAt
    evaluationCount
    createdAt
    updatedAt
    createdBy
    updatedBy
    compressedId
  }
`;
